import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, Input, Button } from 'antd';
import axiosInstance from '../utils/axios_setup';
import { apiEndpoints } from '../utils/urls';

const Login = () => {
  const [loading, setLoading] = useState(false);
  const [passwordError, setPasswordError] = useState(''); // For inline error message
  const navigate = useNavigate(); // For navigation

  const handleLogin = (values) => {
    setLoading(true);
    setPasswordError(''); // Reset error before new attempt

    axiosInstance
      .post(apiEndpoints.login, { password: values.password })
      .then((response) => {
        if (response.status === 200) {
          const { access_token } = response.data.data;
          localStorage.setItem('ses_access_token', access_token); // Save the token
          setPasswordError(''); // Clear error

          // Redirect to the home page
          navigate('/');
        }
      })
      .catch((error) => {
        if (error.response?.status === 400) {
          const errorMessage = error.response.data.message || 'Invalid password!';
          setPasswordError(errorMessage); // Show the error inline
        } else {
          setPasswordError('An unexpected error occurred. Please try again.');
        }
      })
      .finally(() => {
        setLoading(false); // Always stop loading
      });
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.header}>Login</h1>
      <Form layout="vertical" onFinish={handleLogin} style={styles.form}>
        <Form.Item
          label="Password"
          name="password"
          validateStatus={passwordError ? 'error' : ''}
          help={passwordError} // Display error message below input
          rules={[{ required: true, message: 'Please enter your password!' }]}
        >
          <Input.Password placeholder="Enter your password" />
        </Form.Item>
        <Button type="primary" htmlType="submit" loading={loading} style={{ width: '100%' }}>
          Login
        </Button>
      </Form>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: '400px',
    margin: '50px auto',
    padding: '20px',
    backgroundColor: '#fff',
    borderRadius: '8px',
    boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
  },
  header: {
    textAlign: 'center',
    marginBottom: '20px',
  },
  form: {
    marginTop: '20px',
  },
};

export default Login;
